export enum CommunicationAudienceTypeEnum {
  CSV = 'csv',
  BROADCAST = 'broadcast',
}
